import apiList from '@/api/apiList';

export default {
  data() {
    return {
      deviceType: String,
    };
  },
  mounted() {
    this.deviceType = this.$store.state.nativeStore.device;
  },
  methods: {
    async certResult(cert) {
      let url;
      switch (cert.crtfcMthSeCode) {
        case '01':
          url = '/api/v1.0.0/webapp/commonCert/phone-result';
          break;
      }

      const params = {
        mdlTkn: cert.mdlTkn,
        crtfcMthSeCode: cert.crtfcMthSeCode,
      };

      let res;

      try {
        const response = await apiList.certResult(url, params);

        res = {
          result: '',
          crtfcMthSeCode: params.crtfcMthSeCode,
          data: response.data.data,
          mberInfoResult: '',
        };

        if (response.data.data.RSLT_CD === 'B123') {
          // 취소
          res.result = 'cancel';
        } else if (response.data.data.RSLT_CD === 'B000') {
          //검증 제외 회원 확인 250317
          const memberIdentify = await apiList.getMemberIdentify({memberManageType: 'PASSWORD_SPOINT_PASS', mberNo: this.$store.state.mberInfo.mberNo})

          if(memberIdentify.data.data) { //특정 회원 신포검증 제외 250317
            res.result = 'success';
            res.mberInfoResult = 'success';
          } else {
            // 회원 검증
            const mberInfo = await apiList.checkMberInfo({ cino: response.data.data.CI });

            res.result = 'success';
            res.mberInfoResult = mberInfo.data.data.successCnt === 1 ? 'success' : 'fail';
          }
        } else {
          // 나머지 에러(KCB)
          console.error(response.data.data.RSLT_CD, response.data.data.RSLT_MSG);

          res.result = 'fail';
        }
      } catch (error) {
        console.error(error);
        res.result = 'fail';
        alert(JSON.stringify(error));
      }

      return res;
    },

    async sendData(data) {
      if (this.deviceType === 'web') {
        if (window.opener) {
          window.opener = window.opener;
        } else {
          window.opener = window.open('', 'base');
        }
        window.opener.store.commit('certCallback', data);
        setTimeout(() => {
          window.close();
        }, 1000);
      } else if (this.deviceType === 'and') {
        const certRes = data;
        if (certRes.result === 'success') {
          // tkn을 사용하여 인증 정보 조회
          const certInfo = await this.certResult(certRes);

          if (certInfo.result === 'success') {
            if (certInfo.mberInfoResult === 'success') {
              await this.$router.replace({ name: 'mberPassword', params: { certInfo: certInfo.data } });
            } else {
              await this.$router.replace({ name: 'setting', params: { error: '입력하신 인증 정보와 고객정보가 일치하지 않습니다.<br> 다시 확인해 주세요.' } });
            }
          } else if (certInfo.result === 'cancel') {
            await this.$router.replace({ name: 'setting' });
          } else {
            await this.$router.replace({ name: 'setting', params: { error: '인증 정보 조회 중 오류가 발생했습니다.' } });
          }
        } else {
          await this.$router.replace({ name: 'setting', params: { error: '간편 인증 오류가 발생했습니다.<br>다시 시도해 주세요.' } });
        }
      } else if (this.deviceType === 'ios') {
        if (window.opener) {
          window.opener = window.opener;
        } else {
          window.opener = window.open('', 'base');
        }

        window.opener.store.commit('certCallback', data);
        setTimeout(() => {
          window.close();
        }, 1000);
      }
    },
    getContextPath() {
      return location.href.substr(0, location.href.indexOf(location.host) + location.host.length);
    },
  },
};
